<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
					clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" style="width: 260px" v-if="isAgent" v-model="query.companyId"
					@change="companyChange" filterable clearable placeholder="企业" class="handle-select mr10">
					<el-option v-for="item in companys" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-button size="mini" type="primary" :class="[theme]" icon="el-icon-search"
					@click="handleSearch">搜索</el-button>
				<el-button size="mini" type="primary" :class="[theme]" @click="enterpriseSetMenu"
					v-if="query.companyId&&(isAdmin||isAgent)">分配套餐</el-button>
			</div>

			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" @selection-change="handleSelectionChange"
				:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
				:cell-style="{ padding: '6px' }" stripe v-loading="loading">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="companyName" width="340" label="公司" align="center"></el-table-column>
				<el-table-column prop="cardName" label="品牌" align="center"></el-table-column>
				<el-table-column prop="packageName" label="套餐类型" align="center"></el-table-column>
				<el-table-column prop="content" label="普通包" align="center">
					<template #default="scope">
						<el-tag v-for="item in scope.row.content" :key="item.minutes" size="small"
							style="display: flex;flex-direction: column;margin:6px 0;">{{item.minutes}}分钟{{item.price}}元</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="outside" label="加量包" align="center">
					<template #default="scope">
						<el-tag v-for="item in scope.row.outside" :key="item.minutes" size="small"
							style="display: flex;flex-direction: column;margin: 6px 0;">{{item.minutes}}分钟{{item.price}}元</el-tag>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
			<el-dialog title="分配套餐" v-model="sipAllocationVisible" width="550px" @close="closeDialog">
				<el-form label-width="120px" :model="form" ref="form">
					<el-form-item prop="cardType" label="品牌">
						<el-select size="small" v-model="form.cardsId" filterable clearable placeholder="请选择品牌"
							style="width: 100%;" @change="getCardsId">
							<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
								:value="item.cardsId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="packageName" label="套餐类型">
						<el-select size="small" v-model="form.packageName" filterable clearable placeholder="请选择套餐类型"
							style="width: 100%;" @change="changPackageName">
							<el-option v-for="item in packageNameList" :key="item" :label="item"
								:value="item"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-for="(item, index) in form.menuList" label="套餐" :key="item.key"
						:prop="'menuList.' + index + '.value'">
						<el-input size="small" v-model="item.minutes" style="width: 140px;margin-right: 10px;"
							placeholder="请输入套餐时长" disabled>
							<template #append>分钟</template>
						</el-input>
						<el-input size="small" v-model="item.price" style="width: 140px;margin-right: 10px;"
							placeholder="请输入套餐价格"><template #append>元</template></el-input>
						<el-tooltip :content="`套餐价格不能低于${item.price}元`" placement="top" v-if="item.price">
							<i class="el-icon-question"
								style="color: #f27c27;position: relative;top:-6px;left: -4px;cursor: pointer;"></i>
						</el-tooltip>
					</el-form-item>
					<el-form-item v-for="(item, index) in form.outsideList" label="加量包" :key="item.key"
						:prop="'outsideList.' + index + '.value'">
						<el-input size="small" v-model="item.minutes" style="width: 140px;margin-right: 10px;"
							placeholder="请输入加量包时长" disabled><template #append>分钟</template></el-input>
						<el-input size="small" v-model="item.price" style="width: 140px;margin-right: 10px;"
							placeholder="请输入加量包价格"><template #append>元</template></el-input>
						<el-tooltip :content="`加量包价格不能低于${item.price}元`" placement="top" v-if="item.price">
							<i class="el-icon-question"
								style="color: #f27c27;position: relative;top:-6px;left: -4px;cursor: pointer;"></i>
						</el-tooltip>
					</el-form-item>
					<el-form-item class="dis-end">
						<el-button size="small" @click="closeDialog">取消</el-button>
						<el-button size="small" type="primary" :class="[theme]"
							@click="getCompanyPackageAllocation">确定</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>

		</div>
	</div>
</template>

<script>
	import {
		fetchUserById,
	} from '../api/userIndex';
	import {
		fetchDepartment
	} from '../api/index.js';
	import {
		fetchAgent
	} from '../api/agentIndex.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		agentCompanyJobPackageList,
		agentJobTemplate,
		companyJobPackageAllocation,
		serverList
	} from '../api/cdrBatch';
	export default {
		name: 'cdrBatchAllocation',
		data() {
			return {
				loading: false,
				defaultProps: {
					children: 'children',
					label: 'label',
				},
				treeDate: [],
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					companyId: '',
					agentId: '',
					userId: localStorage.getItem('user'),
					pageIndex: 1,
					pageSize: 10,
				},
				agents: [],
				companys: [],
				departments: [],
				tableData: [],
				multipleSelection: [],
				isAdmin: false,
				isAgent: false,
				isCompany: false,
				pageTotal: 0,

				role: '',
				form: {
					cardsId: '',
					packageName: ''
				},
				form2: {},
				serverLists: [],
				sipAllocationVisible: false,
				packageNameList: []
			};
		},
		created() {
			this.role = localStorage.getItem('ms_role');
			this.init();
			if (this.role === 'admin') {
				this.isAdmin = true;
				this.isAgent = true;
			}
			if (this.role == 'agent') {
				this.isAgent = true;
			}
			if (this.role == 'company') {
				this.isCompany = true;
				this.getData()
			}
			this.getServerList();
			this.getnodeData();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.number:hover {
				        color: ${this.theme8} !important;
				    }
					.active:hover {
					    color: #fff !important;
					}
					.more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			handleNodeClick(nodeData) {
				if (nodeData.children) {
					this.query.companyId = '';
					this.query.agentId = nodeData.value;
					this.handleSearch()
				} else {
					this.query.companyId = nodeData.value;
					this.handleSearch()
				}
			},
			getnodeData() {
				// 1. 从 localStorage 安全获取 subAgent
				const rawSubAgent = localStorage.getItem('subAgent');
				let subAgent = [];
				try {
					subAgent = rawSubAgent ? JSON.parse(rawSubAgent.toLowerCase()) : [];
				} catch (e) {
					subAgent = []; // 解析失败时默认空数组
				}

				// 2. 获取 Agent 数据
				fetchAgent(localStorage.getItem('user'))
					.then(res => {
						// 3. 确保 res.data 是数组
						const dataList = Array.isArray(res?.data) ? res.data : [];
						// 4. 使用 Promise.all 处理并发请求
						const promises = dataList.map(item => {
							const data = {
								subAgent: subAgent, // 使用已解析的 subAgent
								agentId: item.value
							};
							return fetchCompanyByAgentId(data)
								.then(ress => {
									// 5. 确保 ress.data 是数组
									const children = Array.isArray(ress?.data) ? ress.data : [];
									return {
										...item,
										children
									}; // 返回新对象，避免副作用
								})
								.catch(error => {
									return {
										...item,
										children: []
									}; // 失败时返回空 children
								});
						});

						// 6. 等待所有请求完成
						return Promise.all(promises);
					})
					.then(allItems => {
						// 7. 一次性更新 treeDate，避免多次 push
						this.treeDate = allItems;
					})
					.catch(error => {
						console.error("获取 Agent 失败:", error);
					});
			},

			//sip服务器列表
			getServerList() {
				let data = {
					pageIndex: 1,
					pageSize: 100,
				}
				serverList(data).then(res => {
					if (res?.code === 200) {
						this.serverLists = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				let data = {
					companyId: '',
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
				this.getfetchDefaultCompanies();


			},
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId
				};
				fetchDefaultCompanies(data).then(res => {
					if (res?.code === 200) {
						this.companys = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getData() {
				let data = {
					userId: localStorage.getItem('user'),
					agentId: this.query.agentId,
					companyId: this.query.companyId,
					pageIndex: this.query.pageIndex,
					pageSize: this.query.pageSize,
				};
				this.loading = true;
				agentCompanyJobPackageList(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.userId = '';
				this.query.companyId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			companyChange(companyId) {
				this.query.companyId = companyId;
				this.query.userId = '';
				this.query.companyId = companyId;
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
					this.query.pageIndex = 1;
					this.getData();
				});
			},

			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getData();
			},
			enterpriseSetMenu() {
				this.sipAllocationVisible = true;
				this.form.cardsId = '';
				this.form.packageName = '';
				this.form.menuList = [];
				this.form.outsideList = [];
			},
			getCardsId() {
				this.packageNameList = [];
				let data = {
					agentId: this.query.agentId,
					cardsId: this.form.cardsId,
					userId: localStorage.getItem('user')
				}
				agentJobTemplate(data).then(res => {
					if (res?.code === 200) {
						res.data.forEach(i => {
							this.packageNameList.push(i.packageName)
						})
						this.form2 = res.data
					} else {
						this.$message.error(res.message);
					}
				});
			},
			changPackageName(e) {
				this.form2.forEach(i => {
					if (i.packageName == e) {
						this.form.menuList = i.content;
						this.form.outsideList = i.outside;
						this.form.id = i.id;
					}
				})
			},
			getCompanyPackageAllocation() {
				this.form.content = [];
				this.form.outside = [];
				this.form.menuList.forEach(i => {
					this.form.content.push(i.minutes + '-' + i.price)
				})
				this.form.outsideList.forEach(i => {
					this.form.outside.push(i.minutes + '-' + i.price)
				})
				let data = {
					agentId: this.query.agentId,
					userId: localStorage.getItem('user'),
					id: this.form.id,
					cardsId: this.form.cardsId,
					companyId: this.query.companyId,
					content: this.form.content.join(),
					outside: this.form.outside.join(),
				}
				companyJobPackageAllocation(data).then(res => {
					if (res?.code === 200) {
						this.sipAllocationVisible = false;
						this.form.packageName = '';
						this.$message.success(res.message);
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeDialog() {
				this.sipAllocationVisible = false;
				this.form.packageName = '';
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 8px 16px;
		font-size: 12px;
		border-radius: 4px;
		margin-left: 10px;

		display: inline-block;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.grid-con-icon {
		font-size: 50px;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		color: #fff;
	}

	.grid-cont-right {
		flex: 1;
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		color: #999;
	}

	.grid-content {
		display: flex;
		align-items: center;
		height: 100px;
	}
</style>
<style>
	.import-visible .el-upload {
		width: 100% !important;
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		justify-content: center !important;
	}
</style>